export const GET_AFTER_SALES_LOG = "GET_AFTER_SALES_LOG";
export const CLEAR_AFTER_SALES_LOG = "CLEAR_AFTER_SALES_LOG";
export const SET_SELECTED_SALES_LOG = "SET_SELECTED_SALES_LOG";
export const SET_AFTER_SALES_LOADING_STATUS = 'SET_AFTER_SALES_LOADING_STATUS'